// Used to store project information for the Projects component
const projectsInfo = [
    {
        id: 1,
        showcaseImg: 'project-card-01.jpeg',
        showcaseName: 'Short Project title',
        name: 'Project title',
        date: '2023-01-01',
        address: '123 Main St, City, Country',
        style: 'Modern',
        colors: ['#000000', '#000000', '#58691c', '#bd9d80'],
        content: [
            { type: 'largeImage', content: 'project-card-01.jpeg' },
            { type: 'paragraph', content: ['<strong>Sleek furniture</strong>, monochromatic tones, and <strong>natural light</strong> define your ideal home. Accents like <strong>geometric patterns, metal finishes</strong>, or a pop of color add just the right amount of personality without overwhelming the space.', '<strong>Sleek furniture</strong>, monochromatic tones, and <strong>natural light</strong> define your ideal home. Accents like <strong>geometric patterns, metal finishes</strong>, or a pop of color add just the right amount of personality without overwhelming the space.'] },
            { type: 'sideBySideImages', content: ['project-card-02.jpeg', 'project-card-03.jpeg'] },
        ],
    },
    {
        id: 2,
        showcaseImg: 'project-card-02.jpeg',
        showcaseName: 'Short Project title',
        name: 'Project title',
        date: '2023-01-01',
        address: '123 Main St, City, Country',
        style: 'Modern',
        colors: ['#FF5733', '#33FF57', '#3357FF'],
        content: [
            { type: 'largeImage', content: 'porject-card-02.jpg' },
            { type: 'sideBySideImages', content: ['porject-card-02.jpg', 'porject-card-02.jpg'] },
            { type: 'paragraph', content: ['<strong>Sleek furniture</strong>, monochromatic tones, and <strong>natural light</strong> define your ideal home. Accents like <strong>geometric patterns, metal finishes</strong>, or a pop of color add just the right amount of personality without overwhelming the space.', '<strong>Sleek furniture</strong>, monochromatic tones, and <strong>natural light</strong> define your ideal home. Accents like <strong>geometric patterns, metal finishes</strong>, or a pop of color add just the right amount of personality without overwhelming the space.'] },
        ],
    },
    {
        id: 3,
        showcaseImg: 'project-card-03.jpeg',
        showcaseName: 'Short Project title',
        name: 'Project title',
        date: '2023-01-01',
        address: '123 Main St, City, Country',
        style: 'Modern',
        colors: ['#FF5733', '#33FF57', '#3357FF'],
        content: [
            { type: 'sideBySideImages', content: ['porject-card-02.jpg', 'porject-card-02.jpg'] },
            { type: 'largeImage', content: 'porject-card-02.jpg' },
            { type: 'paragraph', content: ['<strong>Sleek furniture</strong>, monochromatic tones, and <strong>natural light</strong> define your ideal home. Accents like <strong>geometric patterns, metal finishes</strong>, or a pop of color add just the right amount of personality without overwhelming the space.', '<strong>Sleek furniture</strong>, monochromatic tones, and <strong>natural light</strong> define your ideal home. Accents like <strong>geometric patterns, metal finishes</strong>, or a pop of color add just the right amount of personality without overwhelming the space.'] },
        ],
    },
    {
        id: 4,
        showcaseImg: 'porject-card-04.jpg',
        showcaseName: 'Short Project title',
        name: 'Project title',
        date: '2023-01-01',
        address: '123 Main St, City, Country',
        style: 'Modern',
        colors: ['#FF5733', '#33FF57', '#3357FF'],
        content: [
            { type: 'largeImage', content: 'porject-card-02.jpg' },
            { type: 'paragraph', content: ['<strong>Sleek furniture</strong>, monochromatic tones, and <strong>natural light</strong> define your ideal home. Accents like <strong>geometric patterns, metal finishes</strong>, or a pop of color add just the right amount of personality without overwhelming the space.', '<strong>Sleek furniture</strong>, monochromatic tones, and <strong>natural light</strong> define your ideal home. Accents like <strong>geometric patterns, metal finishes</strong>, or a pop of color add just the right amount of personality without overwhelming the space.'] },
            { type: 'sideBySideImages', content: ['porject-card-02.jpg', 'porject-card-02.jpg'] },
        ],
    },
    {
        id: 5,
        showcaseImg: 'porject-card-05.jpg',
        showcaseName: 'Short Project title',
        name: 'Project title',
        date: '2023-01-01',
        address: '123 Main St, City, Country',
        style: 'Modern',
        colors: ['#FF5733', '#33FF57', '#3357FF'],
        content: [
            { type: 'largeImage', content: 'porject-card-02.jpg' },
            { type: 'paragraph', content: ['<strong>Sleek furniture</strong>, monochromatic tones, and <strong>natural light</strong> define your ideal home. Accents like <strong>geometric patterns, metal finishes</strong>, or a pop of color add just the right amount of personality without overwhelming the space.', '<strong>Sleek furniture</strong>, monochromatic tones, and <strong>natural light</strong> define your ideal home. Accents like <strong>geometric patterns, metal finishes</strong>, or a pop of color add just the right amount of personality without overwhelming the space.'] },
            { type: 'sideBySideImages', content: ['porject-card-02.jpg', 'porject-card-02.jpg'] },
        ],
    },
    {
        id: 6,
        showcaseImg: 'porject-card-06.jpg',
        showcaseName: 'Short Project title',
        name: 'Project title',
        date: '2023-01-01',
        address: '123 Main St, City, Country',
        style: 'Modern',
        colors: ['#FF5733', '#33FF57', '#3357FF'],
        content: [
            { type: 'largeImage', content: 'porject-card-02.jpg' },
            { type: 'paragraph', content: ['<strong>Sleek furniture</strong>, monochromatic tones, and <strong>natural light</strong> define your ideal home. Accents like <strong>geometric patterns, metal finishes</strong>, or a pop of color add just the right amount of personality without overwhelming the space.', '<strong>Sleek furniture</strong>, monochromatic tones, and <strong>natural light</strong> define your ideal home. Accents like <strong>geometric patterns, metal finishes</strong>, or a pop of color add just the right amount of personality without overwhelming the space.'] },
            { type: 'sideBySideImages', content: ['porject-card-02.jpg', 'porject-card-02.jpg'] },
        ],
    },
    {
        id: 7,
        showcaseImg: 'porject-card-07.jpg',
        showcaseName: 'Short Project title',
        name: 'Project title',
        date: '2023-01-01',
        address: '123 Main St, City, Country',
        style: 'Modern',
        colors: ['#FF5733', '#33FF57', '#3357FF'],
        content: [
            { type: 'largeImage', content: 'porject-card-02.jpg' },
            { type: 'paragraph', content: ['<strong>Sleek furniture</strong>, monochromatic tones, and <strong>natural light</strong> define your ideal home. Accents like <strong>geometric patterns, metal finishes</strong>, or a pop of color add just the right amount of personality without overwhelming the space.', '<strong>Sleek furniture</strong>, monochromatic tones, and <strong>natural light</strong> define your ideal home. Accents like <strong>geometric patterns, metal finishes</strong>, or a pop of color add just the right amount of personality without overwhelming the space.'] },
            { type: 'sideBySideImages', content: ['porject-card-02.jpg', 'porject-card-02.jpg'] },
        ],
    },
    {
        id: 8,
        showcaseImg: 'porject-card-08.jpg',
        showcaseName: 'Short Project title',
        name: 'Project title',
        date: '2023-01-01',
        address: '123 Main St, City, Country',
        style: 'Modern',
        colors: ['#FF5733', '#33FF57', '#3357FF'],
        content: [
            { type: 'largeImage', content: 'porject-card-02.jpg' },
            { type: 'paragraph', content: ['<strong>Sleek furniture</strong>, monochromatic tones, and <strong>natural light</strong> define your ideal home. Accents like <strong>geometric patterns, metal finishes</strong>, or a pop of color add just the right amount of personality without overwhelming the space.', '<strong>Sleek furniture</strong>, monochromatic tones, and <strong>natural light</strong> define your ideal home. Accents like <strong>geometric patterns, metal finishes</strong>, or a pop of color add just the right amount of personality without overwhelming the space.'] },
            { type: 'sideBySideImages', content: ['porject-card-02.jpg', 'porject-card-02.jpg'] },
        ],
    },
    // 其他项目
];

export default projectsInfo;